<template>
    <!-- id="jswebrtc" -->
    <video
        :id="webrtcId"
        :time="time"
        :rate="rate"
        ref="player"
        muted
        :autoplay="autoplay"
        :controls="controls"
        :style="{height: webrtcId === 'history' ? 'calc(100vh - 330px)': 'calc(100vh - 260px)'}"
        style="width: 100%;object-fit: fill;"
    ></video>

    <div class="progressDiv" v-if="webrtcId === 'history' && loadVisible">
        <el-icon v-if="playVisible" @click="playVideo" size="20" style="margin-right: 20px;"><VideoPlay /></el-icon>
        <el-icon v-else @click="pauseVideo" size="20" style="margin-right: 20px;"><VideoPause /></el-icon>
        
        <div class="jdtDiv">
            <div ref="dotDiv" class="dot" :style="{ left: progress + '%' }" @mousedown="startDrag"></div>
            <!-- @mouseleave="isDragging = false" -->
            <el-progress id="progress" ref="progress" :percentage="progress" @mousedown="skipToTime" :show-text="false" :stroke-width="12"/>
        </div>
        <div class="timeDiv">
            {{ formatTime(this.backTime) }} / {{ formatTime(this.time) }}
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import debounce from 'lodash/debounce';
export default {
    name: 'WebRTCPlayer',
    emits: ["timeClick","loadClick"],
    props: {
        webrtcId:{type: String, default: ''},
        videoSrc: {type: String, default: ''},
        controls: {type: Boolean, default: true},
        autoplay: {type: Boolean, default: true},
        time: {type: Number, default: 0},
        rate: {type: Number, default: 1},
    },
    data () {
        return {
            progress: 0,
            player: null,
            dotPosition: 0,
            isDragging: false,
            startX: 0,
            backTime: null,
            playVisible: false,
            timerId: null,
            loadVisible: false,
        }
    },
    mounted() {
        // this.$nextTick(() => {
        //     this.startPlaying(this.videoSrc);
        // })
    },
    methods: {
        startPlaying(url) {
            let that = this
            if (that.player) {
                that.stopPlaying();
            }
            const videoElement = document.getElementById(that.webrtcId);
            that.player = new JSWebrtc.Player(url, {
                video: videoElement,
                onplay: (obj) => console.log('Stream started playing')
            });

            videoElement.addEventListener('play', () => {
                this.$emit('loadClick')
                this.loadVisible = true
                if(this.webrtcId === 'history'){
                    this.startTimer()
                }
            });
            // if(this.webrtcId === 'history'){
            //     videoElement.addEventListener('play', () => {
            //         this.Loading = false
            //         this.startTimer()
            //     });
            // }
        },
        startTimer() {
            this.timerId = setTimeout(() => {
                if (this.playVisible) {
                    // 如果需要停止，则不继续递归调用
                    return;
                }
                // 执行你的代码
                this.refreshTime() 
                // 递归调用以重新开始计时
                this.startTimer();
            }, 1000);
        },
        pauseVideo(){
            if(this.player){
                const videoElement = document.getElementById(this.webrtcId);
                videoElement.pause();
                this.playVisible = true
            }
        },
        playVideo(){
            if(this.player){
                // this.player.play()
                const videoElement = document.getElementById(this.webrtcId);
                videoElement.play();
                this.playVisible = false
            }
        },
        refreshTime(){
            if(this.webrtcId === 'history' && !this.isDragging){
                // if(this.playVisible === false){
                    console.log(this.playVisible)
                    let bounds = document.getElementById("progress");
                    if(!bounds) return
                    let boundsPro = bounds.getBoundingClientRect()
                    // const maxWidth = this.$refs.progress.width - 20;
                    const maxWidth = boundsPro.width;
                    let step = (1/this.time)*100
                    this.progress += this.rate * step
                    this.backTime += this.rate
                    if(this.progress === maxWidth){
                        clearInterval(this.timerId);
                    }
                // }
            }
        },
        updateProgress: _.throttle(function(){
        // updateProgress: debounce(function(){
            // if(this.webrtcId === 'history' && !this.isDragging){
            //     const video = document.getElementById(this.webrtcId);
            //     this.progress = (video.currentTime / this.time) * 100;
            // }
        },100),
        stopPlaying() {
            this.player.destroy();
            this.player = null;
            // 停止定时器
            if(this.timerId){
                clearInterval(this.timerId);
            }
        },
        skipToTime(e){
            e.preventDefault();
            let bounds = document.getElementById("progress");
            let boundsPro = bounds.getBoundingClientRect()
            let progress = (e.clientX - boundsPro.left) / boundsPro.width;
            progress = Math.max(0, Math.min(1, progress));
            this.progress = progress * 100;
            this.backTime = this.time * progress
            if(this.backTime){
                let time = Math.floor(this.backTime);
                this.$emit('timeClick', time)
            }
        },
        startDrag(event) {
            event.preventDefault();
            this.isDragging = true;
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.stopDrag);
            document.addEventListener('mouseleave', this.stopDrag);
            this.handleDrag(event);
        },
        handleDrag(event){
            if (this.isDragging) {
                let bounds = document.getElementById("progress");
                let boundsPro = bounds.getBoundingClientRect()
                let progress = (event.clientX - boundsPro.left) / boundsPro.width;
                // const maxWidth = this.$refs.progress.width - 20;
                // let newPosition = Math.max(0, Math.min(100, (this.progress + (moveX / maxWidth) * 100))); 
                progress = Math.max(0, Math.min(1, progress));
                this.progress = progress * 100;
                this.backTime = this.time * progress
            }
        },
        stopDrag() {
            if(this.backTime){
                let time = Math.floor(this.backTime);
                this.$emit('timeClick', time)
            }
            this.isDragging = false;
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.stopDrag);
            document.removeEventListener('mouseleave', this.stopDrag);
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            seconds = Math.floor(seconds % 60);
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        },
    },
    watch: {
        videoSrc: {
            handler(newVal){
                if (newVal && newVal !== '') {
                    this.$nextTick(() => {
                        this.startPlaying(newVal);
                    })
                } else if (newVal === "" && this.player) {
                    this.stopPlaying();
                }
            },
            immediate: true
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.stopPlaying();
        }
    },
};
</script>

<style lang="less" scoped>
.videoCSS{
    width: 100%;
    height: 100%;
    object-fit: fill;
}
.playDiv{
    position: absolute;
    left: 30px;
    bottom: 60px;
    z-index: 99;
}
.progressDiv{
    margin: 10px 0;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.timeDiv{
    font-size: 14px;
    width: 100px;
    margin-left: 20px;
}
.jdtDiv{
    position: relative;
    width: calc(100% - 130px);
    height: 8px;
    background: rgba(204, 204, 204, 0.6);
    border-radius: 6px;
}
.dot {
    width: 16px;
    height: 16px;
    background-color: #409EFF;
    border-radius: 50%;
    position: absolute;
    top: -2px;
    cursor: pointer;
    transform: translateX(-50%);
    // transform: translate(-50%, -50%);
    z-index: 99;
}
.dot:hover {
    transform: translateX(-50%) scale(1.2);
}
.dot.active {
    background-color: #409eff;
    transform: translateX(-50%) scale(1.3);
}
</style>